import { render, staticRenderFns } from "./ModalMakePayment.vue?vue&type=template&id=256c0a0b&scoped=true&"
import script from "./ModalMakePayment.vue?vue&type=script&lang=ts&"
export * from "./ModalMakePayment.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMakePayment.vue?vue&type=style&index=0&id=256c0a0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c0a0b",
  null
  
)

export default component.exports